<template>
  <div class="continue-section">
    <a class="btn-back" @click="$emit('back')" v-if="enableBack">
      <font-awesome-icon :icon="['fal', 'chevron-circle-left']" size="2x"/>
      &nbsp;
      {{backText}}
    </a>
    <button class="botao azul" @click="$emit('continue')" :disabled="!enableContinue">
      {{continueText}}
    </button>
    <a class="btn-skip" @click="$emit('skip')" v-if="enableSkip">
      {{skipText}}
      &nbsp;
      <font-awesome-icon :icon="['fal', 'chevron-circle-right']" size="2x"/>
    </a>
  </div>
</template>

<script>
export default {
  name: 'ContinueSection',
  props: {
    enableSkip: {
      type: Boolean,
      required: false
    },
    enableBack: {
      type: Boolean,
      required: false
    },
    enableContinue: {
      type: Boolean,
      required: false,
      default: true
    },
    skipText: {
      type: String,
      required: false,
      default: 'Pular'
    },
    backText: {
      type: String,
      required: false,
      default: 'Voltar'
    },
    continueText: {
      type: String,
      required: false,
      default: 'CONTINUAR'
    },
    buttonType: {
      type: String,
      required: false,
      default: 'submit'
    }
  }
}
</script>

<style scoped lang="scss">
  .continue-section {
    text-align: center;
    margin-top: 30px;
    position: relative;

    button {
      width: 50%;
      text-transform: uppercase;
    }

    .btn-skip, .btn-back {
      top: 7px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      position: absolute;
    }

    .btn-skip {
      right: 0;
    }

    .btn-back {
      left: 0;
    }
  }
</style>
